import { createAction, props } from '@ngrx/store';
import { IPolicyListItem } from 'src/app/core/interfaces/shared/components/IPolicyListItem';
import { IGetPolicyListResponse } from './policy.models';

export const savePolicyList = createAction(
  '[Policy] Save policy list',
  props<{ list: IGetPolicyListResponse[] }>()
);

export const setPolicy = createAction(
  '[Policy] Set a specific policy from contracts',
  props<{ policyItem: IPolicyListItem }>()
);

